import React from "react";

export default function TransactionSummary({ data }) {
  return (
    <div className="flex flex-wrap justify-between">
      {data.map((item, index) => {
        return (
          <div
            key={index}
            className="flex justify-center items-center cursor-pointer m-2 p-5 md:w-32 w-full bg-white rounded-lg border border-gray-200 shadow-md"
          >
            <div>
              <div
                className={`flex rounded-full border-4 border-${item.fill}-500 text-center w-20 h-20`}
              >
                <div className="m-auto">{item.total}</div>
              </div>
              <div className="mt-2 font-bold text-center">{item.name}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
